<template>
  <div class="box">
    <div @click="clickOption" class="option" v-for="option in options" v-bind:key="option.id" :data-id="option.id">
      {{ option.item }}
    </div>
    <div @click="clickUnknown" class="option unknown" data-id="-1">
      不知道
    </div>
  </div>
</template>

<script>
import common from "../../common";

export default {
  name: "TestWordOption",
  props: {
    options: { type: Array },
    voice_play: { type: Boolean },
    record_initial_time: { type: Number, default: 0 },
  },
  data() {
    return {
      seq: 1,
      selectedOptions: [],
    }
  },
  updated() {
    this.resetOptions();
  },
  methods: {
    clickOption: function (e) {
      if (!this.voice_play) {
        const hasSelectedUnknown = this.selectedOptions.find(item => item.dataset.id === '-1');
        if (hasSelectedUnknown) {
          this.selectedOptions.splice(this.selectedOptions.findIndex(item => item.dataset.id === '-1'), 1);
        }

        const selected_length = document.getElementsByClassName('selected').length;
        if (selected_length <= 4) {
          e.target.classList.toggle('selected')
        } else {
          e.target.classList.remove('selected')
        }

        const new_selected_length = document.getElementsByClassName('selected').length;
        if (new_selected_length > 0) {
          document.getElementsByClassName('unknown')[0].classList.remove('selected')
          document.getElementsByClassName('unknown')[0].style.display = 'none';
        } else {
          document.getElementsByClassName('unknown')[0].style.display = 'block';
        }
        this.handleSelected(e);
        this.getOption();
        this.getAnswer();
        this.addActionSequence();
      }
    },
    clickUnknown: function (e) {
      if (!this.voice_play) {
        e.target.classList.toggle('selected')
        this.handleSelected(e);
        this.getOption()
        this.getAnswer()
        this.addActionSequence();
      }
    },
    handleSelected: function (e) {
      const hasSelected = this.selectedOptions.find(item => item.dataset.id === e.target.dataset.id);
      if (hasSelected) {
        this.selectedOptions.splice(this.selectedOptions.findIndex(item => item.dataset.id === e.target.dataset.id), 1);
      }
      else {
        if (this.selectedOptions.length <= 4) {
          this.selectedOptions.push(e.target);
        }
      }
    },
    getOption: function () {
      const length = document.getElementsByClassName('selected').length;
      if (length > 0) {
        this.$emit('selectWordOption', true, 0)
      } else {
        this.$emit('selectWordOption', false, 0)
      }
    },
    getAnswer: function () {
      const obj = document.getElementsByClassName('selected');
      const answer = [];
      for (let i = 0; i < obj.length; i++) {
        answer.push(obj[i].dataset.id);
      }

      this.$emit('getAnswer', answer);
    },
    addActionSequence: function () {
      this.$emit('addActionSequence', {
        seq: this.seq++,
        x: event.x * window.devicePixelRatio,
        y: event.y * window.devicePixelRatio,
        input_time: common.getTestRecordTime(this.record_initial_time),
        choice: event.target.dataset.id,
      })
    },
    resetOptions: function () {
      if (this.voice_play && this.selectedOptions.length !== 0) {
        for (let i = 0; i < this.selectedOptions.length; i++) {
          this.selectedOptions[i].classList.remove('selected');
        }
        this.selectedOptions = [];
        document.getElementsByClassName('unknown')[0].style.display = 'block';
      }
    }
  }
}
</script>

<style scoped>
.box {
  display: grid;
  grid-template-columns: repeat(4, minmax(clamp(4.5rem, 11vw, 6rem), 1fr));
  justify-content: center;
  gap: clamp(0.375rem, 1vw, 0.75rem) clamp(0.75rem, 2vw, 1.5rem);
  margin-top: clamp(0.75rem, 2vw, 1.5rem);
  padding: 0 clamp(1rem, 3vw, 2rem);
}

.option {
  text-align: center;
  font-size: var(--ecs-font-md);
  min-height: var(--ecs-option-min-height);
  width: 100%;
  border-radius: var(--ecs-radius-md);
  margin: 0;
  padding: 0.5rem;
  line-height: 1.3;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: normal;
  cursor: default;
}

.unknown {
  grid-column: 2 / span 2;
}

.selected {
  background: #94c43b;
  color: white;
}
</style>
